import { useEffect, useState } from "react";
import { AnyDefinition, DatabaseNode, InferType } from "@lifeat/shared/data-models/definition";
import { useDatabaseContext } from "@contexts/DatabaseContext";

/**
 * A hook that subscribes to a database node and returns the value, which will
 * be updated as the node changes.
 * @param node The node to subscribe to.
 * @return The value of the node, or null if the node does not exist.
 */
function useDbValueListener<TDefinition extends AnyDefinition, TPath extends string>(
    node: DatabaseNode<TDefinition, TPath>,
): InferType<TDefinition> | null | undefined {
    const database = useDatabaseContext();

    const [value, setValue] = useState<InferType<TDefinition> | null | undefined>(null);
    useEffect(() => {
        const unsub = database.subscribe(node, "value", (data) => {
            if (data.success) {
                setValue(data.value);
            }
        });

        return () => unsub();
    }, [node.path]);

    return value;
}
export default useDbValueListener;
